import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./HomePageSettings.css";
import edititem from "../../../components/Images/edititem.svg";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { IconEditFigma } from "../../../Assets/MyIcons";
import { FaEllipsisVertical } from "react-icons/fa6";
import { toast } from "react-toastify";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { connect } from "react-redux";

function HomePageSettings({ onlyPermission, ...props }) {

  const baseUrl = process.env.REACT_APP_Baseurl;
  const homepageOrderIndexApi = `${baseUrl}/admin/HomePage-Order/index`
  const homepageOrderUpdateApi = `${baseUrl}/admin/HomePage-Order/ordering`

  const [seriesid, setSeriesid] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  const [message, setMessage] = useState("");
  // const [seriesidvalue, setSeriesidvalue] = useState("");
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const [homepagesetting, setHomepagesetting] = useState([]);
  const [editsingle_series_id, setEditsingle_series_id] = useState({
    single_series_id: "",
  });
  const [user_detailsidhome, setUser_detailsidhome] = useState();

  const [mobilepagesetting, setMobilepagesetting] = useState([]);
  const [user_detailsidmobile, setUser_detailsidmobile] = useState();
  const [tvpagesetting, setTvpagesetting] = useState([]);
  const [user_detailsidTv, setUser_detailsidTv] = useState();

  const [showSingleSeriesModal, setShowSingleSeriesModal] = useState(false);
  const [homepagepagination, setHomePagePagination] = useState();
  const [homepagelimit, setHomePageLimit] = useState();
  const [mobilepagepagination, setMobilePagePagination] = useState();
  const [mobilepagelimit, setMobilePageLimit] = useState();
  const [tvpagepagination, setTVPagePagination] = useState();
  const [tvpagelimit, setTVPageLimit] = useState();
  const [samsungpagesetting, setSamsungpagesetting] = useState([]);
  const [samsungpagepagination, setSamsungPagePagination] = useState();
  const [samsungpagelimit, setSamsungPageLimit] = useState();
  const [lgpagesetting, setLgpagesetting] = useState([]);
  const [lgpagepagination, setLgPagePagination] = useState();
  const [lgpagelimit, setLgPageLimit] = useState();
  const { fetchRequest } = useMyContext()



  const handleToggleChange = (itemName, currentValue) => {
    const updatedHomepagesetting = homepagesetting.map((item) =>
      item?.name === itemName
        ? { ...item, Web_HomePage_status: currentValue ? 0 : 1 }
        : item
    );
    setHomepagesetting(updatedHomepagesetting);

    if (itemName === "single_series" && currentValue === 0) {
      setShowSingleSeriesModal(true);
    }
  };


  const handleToggleChangemobile = (itemName, currentValue) => {
    const updatedMobilepagesetting = mobilepagesetting.map((item) =>
      item?.name === itemName
        ? { ...item, Mobile_Homesetting_status: currentValue ? 0 : 1 }
        : item
    );
    setMobilepagesetting(updatedMobilepagesetting);
  };
  const handleToggleChangeTv = (itemName, currentValue) => {
    const updatedHomepagesettingtv = tvpagesetting.map((item) =>
      item?.name === itemName
        ? { ...item, TV_HomePage_status: currentValue ? 0 : 1 }
        : item
    );
    setTvpagesetting(updatedHomepagesettingtv);
  };

  const handleToggleChangeSamsung = (itemName, currentValue) => {
    const updatedHomepagesettingSamsung = samsungpagesetting.map((item) =>
      item?.name === itemName
        ? { ...item, Samsung_HomePage_status: currentValue ? 0 : 1 }
        : item
    );
    setSamsungpagesetting(updatedHomepagesettingSamsung);
  };

  const handleToggleChangeLG = (itemName, currentValue) => {
    const updatedHomepagesettingLG = lgpagesetting.map((item) =>
      item?.name === itemName
        ? { ...item, LG_HomePage_status: currentValue ? 0 : 1 }
        : item
    );
    setLgpagesetting(updatedHomepagesettingLG);
  };

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Web-HomePage/index`, {
        headers: headers,
      })
      .then((response) => {
        var homepagesetting = response?.data?.Web_HomePage_Order;
        var editsingle_seriesid = response?.data?.Web_HomePage;
        var resultid = response?.data?.list_of_series;
        var user_detailsid = response?.data?.user_details?.id;
        var home_page_limit = response?.data?.Web_HomePage?.limit;
        var home_page_pagination = response?.data?.Web_HomePage?.pagination;
        setSeriesid(resultid);
        setHomepagesetting(homepagesetting);
        setEditsingle_series_id(editsingle_seriesid);
        setHomePageLimit(home_page_limit);
        setHomePagePagination(home_page_pagination);
        setUser_detailsidhome(user_detailsid);
      })
      .catch((error) => console.log(error));

    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Mobile-HomePage/index`, {
        headers: headers,
      })
      .then((response) => {
        var homepagesetting = response?.data?.Mobile_HomePage_Order;
        var user_detailsid = response?.data?.user_details?.id;
        var mobile_home_page_limit = response?.data?.Mobile_HomePage?.limit;
        var home_page_pagination = response?.data?.Mobile_HomePage?.pagination;
        setMobilePageLimit(mobile_home_page_limit);
        setMobilePagePagination(home_page_pagination);
        setMobilepagesetting(homepagesetting);
        setUser_detailsidmobile(user_detailsid);
      })
      .catch((error) => console.log(error));
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/TV-HomePage/index`, {
        headers: headers,
      })
      .then((response) => {
        var homepagesetting = response?.data?.TV_HomePage_Order;
        var user_detailsid = response?.data?.user_details?.id;
        var tv_home_page_limit = response?.data?.TV_HomePage?.limit;
        var tv_home_page_pagination = response?.data?.TV_HomePage?.pagination;
        setTVPageLimit(tv_home_page_limit);
        setTVPagePagination(tv_home_page_pagination);
        setTvpagesetting(homepagesetting);
        setUser_detailsidTv(user_detailsid);
      })
      .catch((error) => console.log(error));

    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Samsung-HomePage/index`, {
        headers: headers,
      })
      .then((response) => {
        var homepagesetting = response?.data?.Samsung_HomePage_Order;
        var samsung_home_page_limit = response?.data?.Samsung_HomePage?.limit;
        var samsung_home_page_pagination = response?.data?.Samsung_HomePage?.pagination;
        setSamsungPageLimit(samsung_home_page_limit);
        setSamsungPagePagination(samsung_home_page_pagination);
        setSamsungpagesetting(homepagesetting);
      })
      .catch((error) => console.log(error));

    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/LG-HomePage/index`, {
        headers: headers,
      })
      .then((response) => {
        var homepagesetting = response?.data?.LG_HomePage_Order;
        var lg_home_page_limit = response?.data?.LG_HomePage?.limit;
        var lg_home_page_pagination = response?.data?.LG_HomePage?.pagination;
        setLgPageLimit(lg_home_page_limit);
        setLgPagePagination(lg_home_page_pagination);
        setLgpagesetting(homepagesetting);
      })
      .catch((error) => console.log(error));
  }, []);

  async function submitApihome(customSettings) {
    const formData = {};
    const settingsToSave = Array.isArray(customSettings) ? customSettings : homepagesetting;

    settingsToSave.forEach((item) => {
      const Web_HomePage_status = Number.isNaN(parseInt(item?.Web_HomePage_status, 10)) ? 0 : parseInt(item?.Web_HomePage_status, 10);
      formData[item?.name] = Web_HomePage_status;
    });
    formData.user_id = user_detailsidhome;

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Web-HomePage/update`,
        formData,
        { headers: headers }
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Settings updated successfully!");
        setProcessing(false);
        setShowOverlay(false);
      } else {
        toast.error(response.data.message || "Failed to update settings");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving settings");
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitPaginationLimitWeb() {

    if (!homepagepagination || homepagepagination < 1) {
      toast.error("Section Pagination limit is required .");
      return;
    }

    if (!homepagelimit || homepagelimit < 1) {
      toast.error("carousel limit is required .");
      return;
    }

    const formData = {
      user_id: user_detailsidhome,
      pagination: homepagepagination,
      limit: homepagelimit,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Web-HomePage/update`,
        formData,
        { headers }
      );

      if (response.data.status === true) {
        toast.success("Pagination and limit updated successfully !");
        setProcessing(false);
        setShowOverlay(false);

      }
    } catch (error) {
      console.error(error);
      toast.error(error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitPaginationLimitMobile() {

    if (!mobilepagepagination || mobilepagepagination < 1) {
      toast.error("Section Pagination limit is required .");
      return;
    }

    if (!mobilepagelimit || mobilepagelimit < 1) {
      toast.error("Limit value is required .");
      return;
    }

    const formData = {
      user_id: user_detailsidhome,
      pagination: mobilepagepagination,
      limit: mobilepagelimit,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-HomePage/update`,
        formData,
        { headers }
      );

      if (response.data.status === true) {
        toast.success("Pagination and limit updated successfully !");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error);

      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitPaginationLimitTV() {

    if (!tvpagepagination || tvpagepagination < 1) {
      toast.error("Section Pagination limit is required .");
      return;
    }

    if (!tvpagelimit || tvpagelimit < 1) {
      toast.error("Limit value is required .");
      return;
    }

    const formData = {
      user_id: user_detailsidhome,
      pagination: tvpagepagination,
      limit: tvpagelimit,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/TV-HomePage/update`,
        formData,
        { headers }
      );

      if (response.data.status === true) {
        toast.success("Pagination and limit updated successfully !");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitPaginationLimitSamsung() {
    if (!samsungpagepagination || samsungpagepagination < 1) {
      toast.error("Section Pagination limit is required .");
      return;
    }
    if (!samsungpagelimit || samsungpagelimit < 1) {
      toast.error("Limit value is required .");
      return;
    }
    const formData = {
      user_id: user_detailsidhome,
      pagination: samsungpagepagination,
      limit: samsungpagelimit,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };
    setProcessing(true);
    setShowOverlay(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Samsung-HomePage/update`,
        formData,
        { headers }
      );
      if (response.data.status === true) {
        toast.success("Pagination and limit updated successfully !");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitPaginationLimitLG() {
    if (!lgpagepagination || lgpagepagination < 1) {
      toast.error("Section Pagination limit is required .");
      return;
    }
    if (!lgpagelimit || lgpagelimit < 1) {
      toast.error("Limit value is required .");
      return;
    }
    const formData = {
      user_id: user_detailsidhome,
      pagination: lgpagepagination,
      limit: lgpagelimit,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };
    setProcessing(true);
    setShowOverlay(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/LG-HomePage/update`,
        formData,
        { headers }
      );
      if (response.data.status === true) {
        toast.success("Pagination and limit updated successfully !");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      console.error(error);
      toast.error(error);
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitApimobile(customSettings) {
    const formData = {};
    const settingsToSave = Array.isArray(customSettings) ? customSettings : mobilepagesetting;

    settingsToSave.forEach((item) => {
      formData[item?.name] = item?.Mobile_Homesetting_status;
    });
    formData.user_id = user_detailsidmobile;

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Mobile-HomePage/update`,
        formData,
        { headers: headers }
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Mobile settings updated successfully!");
        setProcessing(false);
        setShowOverlay(false);
      } else {
        toast.error(response.data.message || "Failed to update Mobile settings");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving Mobile settings");
      setProcessing(false);
      setShowOverlay(false);
    }
  }
  async function submitApiTV(customSettings) {
    const formData = {};
    const settingsToSave = Array.isArray(customSettings) ? customSettings : tvpagesetting;

    settingsToSave.forEach((item) => {
      formData[item?.name] = item?.TV_HomePage_status;
    });
    formData.user_id = user_detailsidTv;

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/TV-HomePage/update`,
        formData,
        { headers: headers }
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "TV settings updated successfully!");
        setProcessing(false);
        setShowOverlay(false);
      } else {
        toast.error(response.data.message || "Failed to update TV settings");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving TV settings");
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitApiSamsung(customSettings) {
    const formData = {};
    const settingsToSave = Array.isArray(customSettings) ? customSettings : samsungpagesetting;
    settingsToSave.forEach((item) => {
      formData[item?.name] = item?.Samsung_HomePage_status;
    });
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };
    setProcessing(true);
    setShowOverlay(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/Samsung-HomePage/update`,
        formData,
        { headers: headers }
      );
      if (response.data.status === true) {
        toast.success(response.data.message || "Samsung settings updated successfully!");
        setProcessing(false);
        setShowOverlay(false);
      } else {
        toast.error(response.data.message || "Failed to update Samsung settings");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving Samsung settings");
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  async function submitApiLG(customSettings) {
    const formData = {};
    const settingsToSave = Array.isArray(customSettings) ? customSettings : lgpagesetting;
    settingsToSave.forEach((item) => {
      formData[item?.name] = item?.LG_HomePage_status;
    });
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };
    setProcessing(true);
    setShowOverlay(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_Baseurl}/admin/LG-HomePage/update`,
        formData,
        { headers: headers }
      );
      if (response.data.status === true) {
        toast.success(response.data.message || "LG settings updated successfully!");
        setProcessing(false);
        setShowOverlay(false);
      } else {
        toast.error(response.data.message || "Failed to update LG settings");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving LG settings");
      setProcessing(false);
      setShowOverlay(false);
    }
  }
  const [
    validationMessagesingle_series_id,
    setValidationMessagesingle_series_id,
  ] = useState("");
  const [
    isValidationHiddensingle_series_id,
    setIsValidationHiddensingle_series_id,
  ] = useState(true);
  // const [processing, setProcessing] = useState(false);
  // const [showOverlay, setShowOverlay] = useState(false);

  const handlesingleseriesid = (event) => {
    const selectedValue = event.target.value;
    setEditsingle_series_id({ single_series_id: selectedValue });
  };

  const single_series_idInputRef = useRef(null);

  async function seriesidsubmit() {
    let focusInputRef = null;

    if (editsingle_series_id.single_series_id === "") {
      setValidationMessagesingle_series_id("Single Series cannot be empty.");
      setIsValidationHiddensingle_series_id(false);
      focusInputRef = single_series_idInputRef;
    }

    if (focusInputRef) {
      focusInputRef.current.focus();
      return;
    }

    const formData = { single_series_id: editsingle_series_id.single_series_id };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Web-HomePage/Single_Series_Update`,
        formData,
        { headers: headers }
      );

      if (response.data.status === true) {
        // After updating the single series ID, update the homepage setting status as well
        const updatedHomepagesetting = homepagesetting.map((item) =>
          item?.name === "single_series"
            ? { ...item, Web_HomePage_status: 1 }
            : item
        );
        setHomepagesetting(updatedHomepagesetting);
        setShowSingleSeriesModal(false);
        toast.success(response.data.message || "Single Series updated successfully!");

        // Trigger overall save to enable the toggle
        await submitApihome(updatedHomepagesetting);

      } else {
        toast.error(response.data.message || "Failed to update Single Series");
        setProcessing(false);
        setShowOverlay(false);
      }
    } catch (error) {
      toast.error("An error occurred while saving Single Series");
      setProcessing(false);
      setShowOverlay(false);
    }
  }

  const [editUser, seteditUser] = useState({
    user_id: "",
    id: "",
    featured_videos: "",
    featured_series: "",
    featured_episodes: "",
    featured_audios: "",
    featured_livestreams: "",
    latest_videos: "",
    category_videos: "",
    live_videos: "",
    series: "",
    audios: "",
    albums: "",
    Recommendation: "",
    AutoIntro_skip: "",
    continue_watching: "",
    theme_choosen: "",
    prevent_inspect: "",
    artist: "",
    pop_up: "",
    live_category: "",
    videoCategories: "",
    liveCategories: "",
    video_schedule: "",
    single_series: "",
    list_of_series: "",
    single_series_id: "",
    latest_series: "",
    scheduled_publish_video: "",
    scheduled_publish_LiveStream: "",
    partner: "",
    Individual_Partner: "",
    videoSubCategories: "",
    short_series: "",
  });
  const [editUserdata, seteditUserdata] = useState({
    user_id: "",
    id: "",
    featured_videos: "",
    featured_series: "",
    featured_episodes: "",
    featured_audios: "",
    featured_livestreams: "",
    latest_videos: "",
    category_videos: "",
    live_videos: "",
    series: "",
    audios: "",
    albums: "",
    Recommendation: "",
    AutoIntro_skip: "",
    continue_watching: "",
    theme_choosen: "",
    prevent_inspect: "",
    artist: "",
    pop_up: "",
    live_category: "",
    videoCategories: "",
    liveCategories: "",
    video_schedule: "",
    single_series: "",
    list_of_series: "",
    single_series_id: "",
    latest_series: "",
    scheduled_publish_video: "",
    scheduled_publish_LiveStream: "",
    partner: "",
    Individual_Partner: "",
    videoSubCategories: "",
    short_series: "",
  });


  const fetchMenuItems = async () => {
    try {
      const response = await axios.get(
        `${homepageOrderIndexApi}`,
        { headers: headers }
      );
      setMenuItems(response.data.Web_HomePage_Order);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(async () => {
    fetchMenuItems();
  }, []);
  const getFilteredMenuItems = (items) => {
    return items?.filter(item => {
      if (item?.name === 'radio_station') return onlyPermission?.map(Number).includes(40);
      if (item?.name === 'vertical_shorts') return onlyPermission?.map(Number).includes(45);
      if (item?.name === 'horizontal_shorts') return onlyPermission?.map(Number).includes(46);
      if (item?.name === 'promotional_ads_banner') return onlyPermission?.map(Number).includes(48);
      if (item?.name === 'short_series') return onlyPermission?.map(Number).includes(49);
      if (item?.name === 'ads_banner') return onlyPermission?.map(Number).includes(48);
      return true;
    });
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const filteredItems = getFilteredMenuItems(menuItems);
    const reorderedFiltered = Array.from(filteredItems);
    const [movedItem] = reorderedFiltered.splice(result.source.index, 1);
    reorderedFiltered.splice(result.destination.index, 0, movedItem);

    // Merge reordered filtered items back into the full menuItems list
    const newMenuItems = Array.from(menuItems);
    reorderedFiltered.forEach((item, index) => {
      const fullIndex = newMenuItems.findIndex(m => m.id === item.id);
      if (fullIndex !== -1) {
        // We don't actually need to update the full list's order_id here locally 
        // as the API call will handle the persistence.
      }
    });

    setMenuItems(prev => {
      const otherItems = prev.filter(item => !filteredItems.find(f => f.id === item.id));
      return [...reorderedFiltered, ...otherItems]; // This is a simple approach
    });

    saveShuffleOrder(reorderedFiltered);
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const saveShuffleOrder = async (data) => {
    if (!data || data?.length === 0) {
      console.log(`Menu items are empty`);

    }

    const ids = data.map(item => item.id);
    const positions = data.map((_, index) => index + 1);

    const requestData = {
      id: ids,
      position: positions,
    };

    try {
      const result = await fetchRequest({
        method: 'PATCH',
        url: `${homepageOrderUpdateApi}`,
        data: requestData
      })

      if (result?.status) {
        toast.success(result?.message)
        setMenuItems(result?.Web_HomePage_Order)
      }

    } catch (error) {
      toast.error(`${error?.response?.message}`);

    }
  }



  return (
    <>
      <div>
        {showOverlay && <Response_Processing></Response_Processing>}
      </div>

      <div className=" m-0 p-0 ">
        <section className="section container-fluid theme-bg-color pt-3">
          <div className="paginate-value">
            <div className="paginate-container">
              <MessageLabel text={"Section Pagination limit"} />
              <AdminCustomInput type="number" min={1} value={homepagepagination} onChange={(e) => setHomePagePagination(Number(e.target.value))} placeHolder={"Enter number value"} />
            </div>
            <div className="paginate-container">
              <MessageLabel text={"carousel limit"} />
              <AdminCustomInput type="number" min={1} value={homepagelimit} onChange={(e) => setHomePageLimit(Number(e.target.value))} placeHolder={"Enter number value"} />
            </div>
            <div className="paginate-container pt-5">
              <AdminCustomButton saveMethod={submitPaginationLimitWeb} saveText={"Submit"} className="ms-auto d-flex justify-content-center" loading={showOverlay} />
            </div>
          </div>
          <div className="p-0">
            <div id="webhomesetting">
              <div className="iq-card home_mobile">
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      <h6>Homepage - Web</h6>
                    </button>
                    <button
                      className="nav-link"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                    >
                      <h6>Homepage - Mobile</h6>
                    </button>

                    <button className="nav-link" id="nav-tv-tab" data-bs-toggle="tab" data-bs-target="#nav-tv" type="button" role="tab" aria-controls="nav-tv" aria-selected="false"><h6>Homepage - TV</h6></button>

                    <button className="nav-link" id="nav-samsung-tab" data-bs-toggle="tab" data-bs-target="#nav-samsung" type="button" role="tab" aria-controls="nav-samsung" aria-selected="false">
                      <h6>Homepage - Samsung</h6>
                    </button>

                    <button className="nav-link" id="nav-lg-tab" data-bs-toggle="tab" data-bs-target="#nav-lg" type="button" role="tab" aria-controls="nav-lg" aria-selected="false">
                      <h6>Homepage - LG</h6>
                    </button>

                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="panel-body mt-3">


                      <div className="row align-items-center p-3">
                        <div className='row mx-0 mb-4 theme-bg-color rounded-2'>
                          {getFilteredMenuItems(homepagesetting)?.map((item, key) => (
                            <div className={`col-12 col-md-6 category-order-title p-1 mb-2`} key={key}>
                              <div className="home">
                                <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                  <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                  <AdminSwitch name={item?.name} checked={item?.Web_HomePage_status} onChange={() => handleToggleChange(item?.name, item?.Web_HomePage_status)} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div
                        className={`modal fade ${showSingleSeriesModal ? "show" : ""
                          }`}
                        tabIndex="-1"
                        role="dialog"
                        style={{
                          display: showSingleSeriesModal ? "block" : "none",
                        }}
                      >
                        <div className="modal-dialog" role="document">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">
                                Single Series Modal
                              </h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() =>
                                  setShowSingleSeriesModal(false)
                                }
                              >
                              </button>
                            </div>
                            <div className="modal-body">
                              <select
                                className="form-select"
                                name="single_series_id"
                                id="single_series_id"
                                value={editsingle_series_id?.single_series_id}
                                onChange={handlesingleseriesid}
                                ref={single_series_idInputRef}
                              >
                                <option value="">Choose a Series</option>
                                {seriesid?.map((item, key) => (
                                  <option key={key} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </select>
                              <span className="errorred">
                                {!isValidationHiddensingle_series_id && (
                                  <p>{validationMessagesingle_series_id}</p>
                                )}
                              </span>


                            </div>
                            <div className="modal-footer">
                              {/* <button
                                      type="button"
                                      className="btn btn-secondary"
                                      data-dismiss="modal"
                                      onClick={() => setShowSingleSeriesModal(false)}
                                    >
                                      Close
                                    </button> */}
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={seriesidsubmit}
                              >
                                Save Single Series
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <AdminCustomButton saveMethod={submitApihome} saveText={"Save Web Settings"} className="ms-auto d-flex justify-content-end" loading={showOverlay} />


                      {/* <div className="row ">
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary mt-3"
                              onClick={handleUpdate}
                              name="submit"
                            >
                              {" "}
                              Save Settings
                            </button>
                          </div>
                        </div> */}
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                  >
                    <div className="panel-body mt-3">
                    
                      <div className="row align-items-center p-3">
                        <div className='row mx-0 mb-4 theme-bg-color rounded-2'>
                          {getFilteredMenuItems(mobilepagesetting)?.map((item, key) => (
                            <div className={`col-12 col-md-6 category-order-title p-1 mb-2`} key={key}>
                              <div className="home">
                                <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                  <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                  <AdminSwitch name={item?.name} checked={item?.Mobile_Homesetting_status} onChange={() => handleToggleChangemobile(item?.name, item?.Mobile_Homesetting_status)} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AdminCustomButton saveMethod={submitApimobile} type="submit" saveText={"Save Mobile Settings"} className="ms-auto d-flex justify-content-end" loading={showOverlay} />
                    </div>
                  </div>

                  <div className="tab-pane fade" id="nav-tv" role="tabpanel" aria-labelledby="nav-tv-tab">
                    <div className="panel-body mt-3">
                      <div className="row align-items-center p-3">
                        <div className='row mx-0 mb-4 theme-bg-color rounded-2'>
                          {getFilteredMenuItems(tvpagesetting)?.map((item, key) => (
                            <div className={`col-12 col-md-12 col-lg-6 category-order-title p-1 mb-2`} key={key}>
                              <div className="home">
                                <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                  <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                  <AdminSwitch name={item?.name} checked={item?.TV_HomePage_status} onChange={() => handleToggleChangeTv(item?.name, item?.TV_HomePage_status)} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AdminCustomButton saveMethod={submitApiTV} type="submit" saveText={"Save TV Settings"} className="ms-auto d-flex justify-content-end" loading={showOverlay} />
                    </div>
                  </div>

                  <div className="tab-pane fade" id="nav-samsung" role="tabpanel" aria-labelledby="nav-samsung-tab">
                    <div className="panel-body mt-3">
                      <div className="row align-items-center p-3">
                        <div className='row mx-0 mb-4 theme-bg-color rounded-2'>
                          {getFilteredMenuItems(samsungpagesetting)?.map((item, key) => (
                            <div className={`col-12 col-md-12 col-lg-6 category-order-title p-1 mb-2`} key={key}>
                              <div className="home">
                                <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                  <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                  <AdminSwitch name={item?.name} checked={item?.Samsung_HomePage_status} onChange={() => handleToggleChangeSamsung(item?.name, item?.Samsung_HomePage_status)} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AdminCustomButton saveMethod={submitApiSamsung} type="submit" saveText={"Save Samsung Settings"} className="ms-auto d-flex justify-content-end" loading={showOverlay} />
                    </div>
                  </div>

                  <div className="tab-pane fade" id="nav-lg" role="tabpanel" aria-labelledby="nav-lg-tab">
                    <div className="panel-body mt-3">
                      <div className="row align-items-center p-3">
                        <div className='row mx-0 mb-4 theme-bg-color rounded-2'>
                          {getFilteredMenuItems(lgpagesetting)?.map((item, key) => (
                            <div className={`col-12 col-md-12 col-lg-6 category-order-title p-1 mb-2`} key={key}>
                              <div className="home">
                                <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                  <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                  <AdminSwitch name={item?.name} checked={item?.LG_HomePage_status} onChange={() => handleToggleChangeLG(item?.name, item?.LG_HomePage_status)} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <AdminCustomButton saveMethod={submitApiLG} type="submit" saveText={"Save LG Settings"} className="ms-auto d-flex justify-content-end" loading={showOverlay} />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <h4 className="admin-title mb-4 theme-text-color text-md-start">
            <MessageBox text="Order Home Page" classname="theme-text-color" />
          </h4>
          <div className="bootstrapTable theme-bg-color p-3 rounded-2">
            <div className="row m-0 theme-border-bottom-secondary pb-3">
              <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"># </label> </div>
              <div className="col-5 "><label className="theme-text-color fw-bold fs-6">Name</label></div>
              <div className="col-5 "><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="menu-items" className="theme-bg-color">
                {(provided) => (
                  <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color list-unstyled m-0 p-0">
                    {getFilteredMenuItems(menuItems)?.map((menuItem, index) => (
                      <Draggable
                        key={menuItem?.id.toString()}
                        draggableId={menuItem?.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <li ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  orderborder ${menuItem.order} index ${index + 1} w-100 theme-border-bottom-secondary`} >
                            <div className="row m-0 p-0 align-items-center">
                              <div className="col-2  category-order-title">
                                <div className='d-flex position-relative '>
                                  <p className="theme-text-color mb-3 admin-input-title d-block position-relative"> {menuItem?.order_id} </p>
                                </div >
                              </div>
                              <div className="col-5  category-order-title">
                                <MessageLabel text={menuItem?.header_name} classname="theme-text-color" noMargin />
                              </div>
                              <div className="col-5  category-order-title">
                                <div className="editdropdown">
                                  <span className="editdropdown-button">
                                    <span>
                                      <FaEllipsisVertical className="theme-text-color" />
                                    </span>
                                  </span>
                                  <div className="editdropdown-menu theme-bg-color">
                                    <Link to={"/edit-orderhome/" + menuItem?.id} className="theme-text-color theme-bg-color">
                                      <span>
                                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                        <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  onlyPermission: state.userPermission.onlyPermission
});

export default connect(mapStateToProps)(HomePageSettings);
